<div class="container">
  <div class="header">
    <button class="back-button" routerLink="/">
      <img src="assets/icons/news/back-arrow.svg" alt="back button" />
      <p>Volver</p>
    </button>
  </div>
  <div class="form-container">
    <div class="header">
      <img src="/assets/icons/news/commerce-logo.svg" alt="commerce-background" />
      <div class="title-section">
        <h1>TiendaCrypto</h1>
        <p>API Commerce</p>
      </div>
    </div>
    <form [formGroup]="formGroup" class="form">
      <h1>Generar cargo</h1>
      <div class="control">
        <label>Nombre producto/servicio</label>
        <mat-form-field appearance="fill">
          <input formControlName="name" autocomplete="off" matInput />
          <mat-error
            for="name"
            class="form-error"
            *ngIf="
              (!formGroup.controls.name.pristine || formGroup.controls.name.touched) &&
              formGroup.controls.name.invalid
            "
          >
            {{ getErrorMessage('name') }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="control">
        <label>Descripción <span>opcional</span></label>
        <mat-form-field class="description" appearance="fill">
          <textarea class="scrollable" formControlName="desc" matInput></textarea>
          <mat-error
            for="desc"
            class="form-error"
            *ngIf="
              (!formGroup.controls.desc.pristine || formGroup.controls.desc.touched) &&
              formGroup.controls.desc.invalid
            "
          >
            {{ getErrorMessage('desc') }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="control">
        <label>Precio</label>
        <div class="multiple-inputs">
          <mat-form-field class="price" appearance="fill">
            <span matPrefix>$</span>
            <input
              placeholder="0.00"
              mask="separator.2"
              thousandSeparator="."
              formControlName="price"
              autocomplete="off"
              matInput
            />
            <mat-error
              for="price"
              class="form-error"
              *ngIf="
                (!formGroup.controls.price.pristine || formGroup.controls.price.touched) &&
                formGroup.controls.price.invalid
              "
            >
              {{ getErrorMessage('price') }}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="currency" appearance="fill">
            <mat-select formControlName="currency">
              <mat-option value="ARS">AR$</mat-option>
              <mat-option value="USD">U$D</mat-option>
              <mat-option value="STABLES">STABLES</mat-option>
            </mat-select>
            <mat-error
              for="currency"
              class="form-error"
              *ngIf="
                (!formGroup.controls.currency.pristine || formGroup.controls.currency.touched) &&
                formGroup.controls.currency.invalid
              "
            >
              {{ getErrorMessage('currency') }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <button
        [disabled]="formGroup.invalid || loading"
        (click)="createCharge()"
        mat-button
        class="td-btn primary"
      >
        {{ loading ? 'Creando cargo...' : 'Confirmar cargo' }}
      </button>
    </form>
  </div>
</div>
<div class="blur-background" [class.hide]="!dialogOpened"></div>
